/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    [
      'เที่ยงคืน', 'n', 'เช้า', 'เที่ยง', 'บ่าย',
      'เย็น', 'ค่ำ', 'กลางคืน'
    ],
    [
      'เที่ยงคืน', 'เที่ยง', 'ในตอนเช้า',
      'ในตอนบ่าย', 'บ่าย', 'ในตอนเย็น', 'ค่ำ',
      'กลางคืน'
    ],
  ],
  [
    [
      'เที่ยงคืน', 'เที่ยง', 'เช้า',
      'ช่วงเที่ยง', 'บ่าย', 'เย็น', 'ค่ำ',
      'กลางคืน'
    ],
    [
      'เที่ยงคืน', 'เที่ยง', 'ในตอนเช้า',
      'ในตอนบ่าย', 'บ่าย', 'ในตอนเย็น', 'ค่ำ',
      'กลางคืน'
    ],
  ],
  [
    '00:00', '12:00', ['06:00', '12:00'], ['12:00', '13:00'], ['13:00', '16:00'],
    ['16:00', '18:00'], ['18:00', '21:00'], ['21:00', '06:00']
  ]
];
